<template>
	<div style="width: 74%; margin: 10px 13%;">
		<div class="news-title">
			<i class="iconfont iconanchor-full"></i>
			<div style="margin: 0 20px;">
				{{details.title}}
			</div>
			<i class="iconfont iconanchor-full"></i>
		</div>
		<div style="width: 100%; height: 600px; margin-top: 30px;">
			<video id="myVideo" class="video-box video-js" style="width: 100%; height: 100%;">

			</video>
		</div>
		<div class="inner-content" v-html="details.txt"></div>
		<div class="back">
			<div class="back-button" @click="backToList">
				更多音视频
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: '',
		data () {
			return {
				newsId: "",
				details: {

				},
				pageList: [],
				pageIndex: 0,
				videoUrl: '',
			}
		},
		mounted() {
			document.body.scrollTop = document.documentElement.scrollTop = 0
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../../../static/search_top.png'
			that.newsId = this.$route.query.news_id
			that.getNewsDetails()
		},
		methods: {
			getNewsDetails() {
				let that = this
				that.$http.post({
					url: '/api/content/getContentById',
					data: {
						id: that.newsId
					}
				}).then(res => {
					if(res.code === 'S200') {
						var poster = ''
						that.details = res.data
						if(res.data.video) {
							that.videoUrl = that.$imgUrl + res.data.video
							that.initVideo(poster)
						}
						if(res.data.audio) {
							that.videoUrl = that.$imgUrl + res.data.audio

							if(res.data.listImgPc) {
								poster = that.$imgUrl + res.data.listImgPc
							}

							that.initVideo(poster)
						}
					}
				})
			},
			backToList() {
				this.$router.push('news_video')
			},
			initVideo(poster) {
				let myPlayer = this.$video(myVideo, {
					//确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
					controls: true,
					//自动播放属性,muted:静音播放
					autoplay: true,
					//建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
					preload: true,
					//设置视频播放器的显示宽度（以像素为单位）
					width: "800px",
					//设置视频播放器的显示高度（以像素为单位）
					height: "400px",
					poster: poster,
					sources: [{ // 播放资源和资源格式
						type: "video/mp4",
						src: this.videoUrl //你的视频地址（先为空，之后动态赋值）
					}],
				});
			}
		}
	}
</script>

<style lang="less" scoped>
	.news-title {
		display: flex;
		height: 50px;
		line-height: 50px;
		font-size: 13px;
		color: #922627;
		text-align: center;
		justify-content: center;
		border-bottom: 3px solid #1059BF;
		i {
			font-size: 17px;
			color: #F8C822;
		}
	}
	.news-xinxi {
		width: 100%;
		height: 70px;
		line-height: 70px;
		display: flex;
		color: #686868;
		font-size: 11px;
	}
	.news-content {
		font-size: 12px;
		color: #333333;
		text-align: left;
		padding: 30px 0;
	}
	.news-image {
		width: 680px;
		margin: 0 auto;
	}
	.back {
		position: relative;
		margin: 30px 0;
		height: 20px;
		.back-button {
			width: 75px;
			height: 20px;
			line-height: 20px;
			margin: 0 auto;
			font-size: 9px;
			border: 1px solid #0E40DF;
			color: #0E40DF;
			text-align: center;
			cursor: pointer;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/news_video/news_video_details.vue